module.exports = __webpack_public_path__ + "img/swipe.97ca1097.png";